import store from "@src/reducers/store";
import apiUseCases from "../../api";
import { errorSnackbar } from "@src/cloud-connect/snackbars/entities/snackbar-launcher";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";

export const findSelectedBlueprintUseCase = async (blueprintUuid) => {
  try {
    const namespace = store.getState().yourSlice.authContext.customerNamespace;
    const blueprintStructure = await apiUseCases.fetchSelectedBlueprint({
      blueprintUuid,
      namespace,
    });

    return blueprintStructure;
  } catch (error) {
    const parsedError = parseAxiosApiError(
      error,
      "Failed to fetch selected blueprint",
    );
    errorSnackbar(parsedError.message);
    return undefined;
  }
};
